<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div *ngIf="context">
    <button class="btn-volver" mat-raised-button (click)="volver()">Volver</button>
    <app-contexto></app-contexto>
</div>

<!-- si esta en la etapa 3 muestra modo entrenamiento -->
<div *ngIf="!context">
    <div class="customers">
        <div class="card">
            <div class="card-body" style="padding: 20px;">

                <div class="row">
                    <div class="col-sm-6" style="text-align: right;">
                        <div class="image-title">
                            <img src="../../../../../assets/icons/02-autoevaluacion@2x.png" alt="avatar" class="title-pic">
                        </div>
                    </div>
                    <div class="col-sm-6" style="text-align: right;">
                        <p style="font: normal normal 600 14px/18px Montserrat;
                            letter-spacing: 0px;
                            color: #30374B;
                            text-transform: uppercase;
                            display: inline-block;
                            opacity: 1;">Estado de Autoevaluación</p>
                        <div style="display: inline-block;
                            background: #F6F6F6 0% 0% no-repeat padding-box;
                            border-radius: 10px;
                            opacity: 1;
                            padding: 15px;
                            margin-left: 15px;">
                            <p class="textoEstado1" *ngIf="dataJardin.etapaJardin===1">No Disponible</p>
                            <p class="textoEstado2" *ngIf="dataJardin.etapaJardin===2">En Curso</p>
                            <p class="textoEstado3" *ngIf="dataJardin.etapaJardin > 2">Finalizada</p>
                        </div>
                    </div>
                </div>

                <!-- ******************************** -->

                <div *ngIf="dataJardin.etapaJardin===1 && jardinTutoria3.idEstadoTutoria === 154">
                    <div class="row">
                        <div class="col-sm-12">
                            <p style="text-align: left;
                                font: normal normal bold 26px/53px Montserrat;
                                letter-spacing: 0px;
                                color: #00B09E;
                                opacity: 1;">Etapa 2: Autoevaluación</p>


                            <p style="text-align: left;
                                letter-spacing: 0px;
                                color: #30374B;
                                opacity: 1;"><b>Lo sentimos.</b></p>
                            <p style="text-align: left;
                                letter-spacing: 0px;
                                color: #30374B;
                                opacity: 1;">Esta sección estará disponible de acuerdo a la etapa del proceso que se encuentre transitando su unidad educativa.</p>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-12" style="text-align: center;">
                            <img src="../../../../../assets/icons/404-wip_1.png" style="width: 300px;margin-bottom: 70px;margin-top: 20px;">
                        </div>

                    </div>

                </div>


                <!-- ******************************** -->
                <div *ngIf="dataJardin.etapaJardin>=2 || jardinTutoria3.idEstadoTutoria != 154 ">
                    <div class="row">
                        <div class="col-12 header-autoevaluacion">
                            <h2>Etapa 2: Autoevaluación <i style="color: #EE366D;" *ngIf="dataJardin.etapaJardin===1">Modo Entrenamiento</i></h2>
                            <p>En esta sección se encuentran disponibles los recursos que le permitirán a su unidad educativa desarrollar el proceso de Autoevaluación. La invitamos a que realice su trabajo de la siguiente manera:</p>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-12 autoevaluacion contexto">
                                            <div class="content">
                                                <h3>Contexto</h3>
                                                <p>En este espacio, la invitamos a contestar las siguientes preguntas, que permitirán reflejar la realidad de su unidad educativa durante el período 2020 - 2021. Para ello, presione el botón <strong>"Declarar contexto"</strong>.</p>
                                            </div>
                                            <button class="btnVerdeSubir" (click)="irContexto()" *ngIf="dataJardin.etapaJardin<=2" [disabled]="this.dataJardin.etapaJardin > 2">DECLARAR CONTEXTO</button>
                                            <button class="btn-ver" (click)="irContexto()" [disabled]="this.dataJardin.etapaJardin <= 2" *ngIf="dataJardin.etapaJardin>2">REVISAR CONTEXTO</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-12 autoevaluacion medios">
                                            <div class="content">
                                                <h3>Medios de Verificación</h3>
                                                <p>Primero, organice en su computador una carpeta con los principales de medios de verificación que acreditan las prácticas de gestión de su unidad educativa, teniendo especial atención en asignarles un nombre
                                                    claro y que permita una fácil identificación. Luego debe subirlos a esta sección web, pinchando en el botón <b>"Subir Medios"</b>.</p>
                                            </div>
                                            <button class="btnVerdeSubir" (click)="verMediosVerificacion()" [disabled]="this.dataJardin.etapaJardin > 2">SUBIR MEDIOS</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="card last">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-12 autoevaluacion guia">
                                            <div class="content">
                                                <h3>Guía de Evaluación <i style="color: #EE366D;" *ngIf="dataJardin.etapaJardin===1"> - Modo Entrenamiento</i></h3>
                                                <p>Posteriormente, a través de este formulario, encontrará los <strong>71 elementos de gestión</strong> que considera el Modelo. Para cada uno de ellos deberá evaluarse y asignarse una calificación compuesta
                                                    por <strong>6 niveles de desempeño</strong>. Luego, a cada elemento de gestión le podrá asociar un máximo de <strong>6 medios de verificación</strong> que sustentan el nivel de desempeño seleccionado.
                                                    Considere que no es obligatorio asociar 6 medios de verificación a cada elemento de gestión, sino sólo aquel o aquellos que sustentan el nivel de la práctica.</p>
                                                <p>Para mayor información, detalles y realizar la Guía de Evaluación, pinche en el botón <strong>"Iniciar"</strong>.</p>
                                            </div>
                                            <button class="btnVerdeSubir" (click)="irA()" *ngIf="dataJardin.etapaJardin<=2" [disabled]="this.dataJardin.etapaJardin > 2">INICIAR</button>
                                            <button class="btn-ver" (click)="irA()" [disabled]="this.dataJardin.etapaJardin <= 2" *ngIf="dataJardin.etapaJardin>2">REVISAR</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ******************************** -->

            </div>
        </div>
    </div>
</div>